import React from 'react'

const AuthenticityToken = () => (
  <input type="hidden" name="authenticity_token" value={document.querySelector('meta[name="csrf-token"]').content} />
)

export default AuthenticityToken
